import {
    ModuleWithProviders,
    NgModule,
} from '@angular/core';
import {
    PageCategory,
    PageScope,
    providePageMeta,
} from '@app/router';
import { FolderType } from '@models';

@NgModule()
export class RobotMetaModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: RobotMetaModule,
            providers: [
                providePageMeta({
                    title: 'Robots',
                    translationKey: 'page_robots',
                    routerLink: '/robots',
                    sidebarSection: 'Management',
                    svgIcon: 'uipath:robots',
                    permission: 'Robots.View',
                    type: 'Sidebar',
                    category: PageCategory.Tenant,
                    scope: PageScope.Folder,
                    folderTypeDependency: FolderType.Classic,
                    folderTypeDependencyMessage: 'page_robots_redirect_users',
                    priority: 2,
                }),
                providePageMeta({
                    title: 'User Activity',
                    translationKey: 'page_user_activity',
                    routerLink: '/user-activity',
                    sidebarSection: 'Monitoring',
                    svgIcon: 'uipath:robots_global',
                    permission: 'Robots.View|Users.View',
                    type: 'Sidebar',
                    category: PageCategory.Tenant,
                    scope: PageScope.Global,
                    priority:  0,
                }),
            ],
        };
    }
}
